import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { freeValidationSchema } from "../helpers";

interface Props {
  userDetails: {
    name: string;
    email: string;
  };
  error: string;
  isSubmitting: boolean;
  setError: (value: string) => void;
  previousAction: (e: any) => void;
  updateUserDetails: (key: string, value: string) => void;
  handleSubmit: (e?: any) => void;
  isCurrentUserPresent: boolean;
}

class FreeForm extends Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  handleChange = (e, key, setFieldValue) => {
    e.persist();

    const value = e.target.value;

    setFieldValue(key, value);

    this.props.updateUserDetails(key, value);
  };

  render() {
    const { userDetails, error, setError, isSubmitting, isCurrentUserPresent } =
      this.props;

    return (
      <div>
        <Formik
          initialValues={userDetails}
          validationSchema={freeValidationSchema}
          onSubmit={() => this.props.handleSubmit()}
        >
          {({ setFieldValue }) => (
            <Form className="ui form">
              {!isCurrentUserPresent && (
                <div className="input-row full">
                  <div className="form-input">
                    <label>Full name</label>
                    <Field
                      id="name"
                      name="name"
                      validate={true}
                      className="required"
                      placeholder="Sherlock Holmes"
                      autoComplete="name"
                      onChange={(e) =>
                        this.handleChange(e, "name", setFieldValue)
                      }
                    />
                    <ErrorMessage name="name">
                      {(msg) => <div className="error">{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              )}
              {!isCurrentUserPresent && (
                <div className="input-row full">
                  <div className="form-input">
                    <label>Email</label>
                    <Field
                      id="email"
                      name="email"
                      validate={true}
                      className="required"
                      placeholder="you@example.com"
                      autoComplete="email"
                      onChange={(e) =>
                        this.handleChange(e, "email", setFieldValue)
                      }
                    />
                    <ErrorMessage name="email">
                      {(msg) => <div className="error">{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
              )}
              {error && (
                <div id="card-errors" role="alert">
                  <i
                    className="close icon util-clickable"
                    onClick={() => setError("")}
                  />
                  <span>{error}</span>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default FreeForm;
